export const mockProductsData = {
	products: [
		{
			id: "prod-1",
			title: "Premium Wireless Earbuds",
			description: "High-quality wireless earbuds with noise cancellation and 24-hour battery life. Water-resistant and perfect for workouts.",
			price: 129.99,
			salePrice: 99.99,
			onSale: true,
			images: [
				"https://images.unsplash.com/photo-1590658268037-6bf12165a8df?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
				"https://images.unsplash.com/photo-1606220838315-056192d5e927?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
				"https://images.unsplash.com/photo-1608156639585-b3a032ef9689?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
			],
			rating: 4.7,
			reviewCount: 124,
			inStock: true,
			tags: ["electronics", "audio", "featured"],
			liveDate: "2023-05-15T00:00:00Z",
			removalDate: "2024-12-31T00:00:00Z",
			comments: [
				{
					id: "comment-1",
					user: "Sarah J.",
					text: "These earbuds are amazing! Great sound quality and the battery lasts forever.",
					rating: 5,
					date: "2023-06-10T14:30:00Z",
				},
				{
					id: "comment-2",
					user: "Michael T.",
					text: "Good sound, but they don't fit my ears very well. Still a solid product.",
					rating: 4,
					date: "2023-07-22T09:15:00Z",
				},
				{
					id: "comment-3",
					user: "Lisa R.",
					text: "The noise cancellation feature is game-changing for my commute.",
					rating: 5,
					date: "2023-08-05T16:45:00Z",
				},
			],
		},
		{
			id: "prod-2",
			title: "Smart Fitness Watch",
			description: "Track your health metrics, workouts, and sleep patterns with this advanced fitness watch. Includes heart rate monitoring and GPS.",
			price: 199.99,
			salePrice: null,
			onSale: false,
			images: [
				"https://images.unsplash.com/photo-1579586337278-3befd40fd17a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1288&q=80",
				"https://images.unsplash.com/photo-1508685096489-7aacd43bd3b1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1286&q=80",
			],
			rating: 4.5,
			reviewCount: 89,
			inStock: true,
			tags: ["electronics", "fitness", "wearable"],
			liveDate: "2023-06-01T00:00:00Z",
			removalDate: null,
			comments: [
				{
					id: "comment-1",
					user: "David K.",
					text: "This watch has really helped me stay on track with my fitness goals.",
					rating: 5,
					date: "2023-06-15T10:20:00Z",
				},
				{
					id: "comment-2",
					user: "Emma W.",
					text: "Battery life could be better, but otherwise it's great.",
					rating: 4,
					date: "2023-07-03T19:45:00Z",
				},
			],
		},
		{
			id: "prod-3",
			title: "Premium Coffee Maker",
			description: "Brew the perfect cup of coffee with this programmable coffee maker. Features temperature control and a built-in grinder.",
			price: 149.99,
			salePrice: 129.99,
			onSale: true,
			images: [
				"https://images.unsplash.com/photo-1517668808822-9ebb02f2a0e6?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
				"https://images.unsplash.com/photo-1577968897966-3d4325b36b61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
			],
			rating: 4.8,
			reviewCount: 205,
			inStock: true,
			tags: ["home", "kitchen", "featured"],
			liveDate: "2023-04-10T00:00:00Z",
			removalDate: null,
			comments: [
				{
					id: "comment-1",
					user: "James B.",
					text: "Best coffee maker I've ever owned. Worth every penny.",
					rating: 5,
					date: "2023-04-25T08:10:00Z",
				},
				{
					id: "comment-2",
					user: "Angela M.",
					text: "Makes delicious coffee and looks great on my countertop.",
					rating: 5,
					date: "2023-05-12T16:30:00Z",
				},
				{
					id: "comment-3",
					user: "Robert T.",
					text: "A bit pricey but delivers excellent quality coffee.",
					rating: 4,
					date: "2023-06-20T11:45:00Z",
				},
			],
		},
		{
			id: "prod-4",
			title: "Portable Bluetooth Speaker",
			description: "Compact, water-resistant Bluetooth speaker with powerful sound and 12-hour battery life. Perfect for outdoor adventures.",
			price: 79.99,
			salePrice: null,
			onSale: false,
			images: [
				"https://images.unsplash.com/photo-1608043152269-423dbba4e7e1?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
				"https://images.unsplash.com/photo-1589003077984-89623f5e7263?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
			],
			rating: 4.3,
			reviewCount: 67,
			inStock: true,
			tags: ["electronics", "audio"],
			liveDate: "2023-05-01T00:00:00Z",
			removalDate: null,
			comments: [
				{
					id: "comment-1",
					user: "Thomas H.",
					text: "Great little speaker for the price. Sound quality is impressive for its size.",
					rating: 4,
					date: "2023-05-18T15:20:00Z",
				},
				{
					id: "comment-2",
					user: "Sophia L.",
					text: "I take this on all my hiking trips. Durable and good battery life.",
					rating: 5,
					date: "2023-06-30T12:10:00Z",
				},
			],
		},
		{
			id: "prod-5",
			title: "Ergonomic Office Chair",
			description: "Comfortable office chair with lumbar support, adjustable height, and breathable mesh back. Ideal for long work sessions.",
			price: 249.99,
			salePrice: 199.99,
			onSale: true,
			images: [
				"https://images.unsplash.com/photo-1517705008128-361805f42e86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
				"https://images.unsplash.com/photo-1519125323398-675f0ddb6308?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
			],
			rating: 4.6,
			reviewCount: 132,
			inStock: true,
			tags: ["home", "office", "furniture"],
			liveDate: "2023-03-15T00:00:00Z",
			removalDate: null,
			comments: [
				{
					id: "comment-1",
					user: "Nina P.",
					text: "My back pain has significantly decreased since I started using this chair.",
					rating: 5,
					date: "2023-04-02T14:50:00Z",
				},
				{
					id: "comment-2",
					user: "Mark J.",
					text: "Assembly was a bit challenging, but the chair is very comfortable.",
					rating: 4,
					date: "2023-05-10T09:30:00Z",
				},
				{
					id: "comment-3",
					user: "Olivia S.",
					text: "Great quality for the price. Highly recommend for home offices.",
					rating: 5,
					date: "2023-06-15T17:40:00Z",
				},
			],
		},
		{
			id: "prod-6",
			title: "Smart Home Security Camera",
			description: "HD security camera with night vision, motion detection, and smartphone alerts. Easy to install and monitor from anywhere.",
			price: 89.99,
			salePrice: null,
			onSale: false,
			images: [
				"https://images.unsplash.com/photo-1557174949-3b1b575ae3f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
				"https://images.unsplash.com/photo-1585771724684-38269d6919f4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1287&q=80",
			],
			rating: 4.4,
			reviewCount: 98,
			inStock: false,
			tags: ["electronics", "smart home", "security"],
			liveDate: "2023-06-20T00:00:00Z",
			removalDate: null,
			comments: [
				{
					id: "comment-1",
					user: "Kevin M.",
					text: "Super easy to set up and the image quality is excellent.",
					rating: 5,
					date: "2023-07-05T11:15:00Z",
				},
				{
					id: "comment-2",
					user: "Patricia D.",
					text: "The app sometimes lags, but the camera itself works well.",
					rating: 3,
					date: "2023-08-12T19:20:00Z",
				},
			],
		},
	],
	quickAccess: {
		enabled: true,
		posts: {
			label: "Post",
			icon: "chatbubble-outline",
			whoCanCreate: "all",
			whoCanView: "all",
		},
		featuredAssets: {
			enabled: true,
			label: "Promote",
			icon: "star-outline",
			whoCanCreate: "admins",
		},
		createAssets: {
			enabled: true,
			label: "New Product",
			icon: "add-circle-outline",
			whoCanCreate: "admins",
			whoCanView: "all",
		},
	},
};
